var themeOptions = function () {
  return {
    components: {
      MuiFormControl: {
        styleOverrides: {
          root: {
            '.MuiIconButton-root': {
              marginBottom: '-2px',
              marginTop: '-4px',
              cursor: 'default'
            }
          }
        }
      }
    }
  };
};
export default themeOptions;